<script setup lang="ts">
defineProps<{ videoId: string }>();
</script>

<template>
  <ScriptVimeoPlayer :id="+videoId" class="w-full!">
    <template #awaitingLoad>
      <div class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded bg-blue-500 px-6 py-2 transition group-hover:bg-blue-700">
        <svg width="24" height="24" viewBox="0 0 24 24" class="size-10 text-white" xmlns="http://www.w3.org/2000/svg">
          <path
            d="
              M19 12C19 12.3557 18.8111 12.6846 18.5039 12.8638 L6.50387 19.8638 C6.19458 20.0442 5.81243 20.0455 5.50194 19.8671
              C5.19145 19.6888 5 19.3581 5 19L5 5C5 4.64193 5.19145 4.3112 5.50194 4.13286
              C5.81243 3.95452 6.19458 3.9558 6.50387 4.13622L18.5039 11.1362 C18.8111 11.3154 19 11.6443 19 12Z" fill="currentColor"
          />
        </svg>
      </div>
    </template>
  </ScriptVimeoPlayer>
</template>

<style scoped>

</style>
